import { useEffect, useState } from 'react'
import { Button, notification } from 'antd'
import { useLocation, useNavigate } from 'react-router-dom'

import { HiOutlineHome } from 'react-icons/hi'
import { MdDashboard, MdSportsHockey } from 'react-icons/md'
import { FaPlusCircle, FaRegChartBar } from 'react-icons/fa'
import { RiAuctionLine, RiDraftLine } from 'react-icons/ri'
import { BsShop } from 'react-icons/bs'
import { GiStarMedal, GiTrade, GiCoins } from 'react-icons/gi'
import { PiUsersThreeLight, PiNotebookLight } from 'react-icons/pi'
import { FaQuestion } from 'react-icons/fa6'
import { AiOutlineSetting } from 'react-icons/ai'
import { TbLivePhoto } from 'react-icons/tb'
import { SiLeagueoflegends } from 'react-icons/si'
import { useSelector } from 'react-redux'
import comissioner from '../assets/comissioner.png'
import LoginDropdown from './LoginDropdown'
import { landingSignup } from '../config/constants'

import Community from '../assets/community.png'
import Job from '../assets/job.png'
import Support from '../assets/support.png'
import FAQ from '../assets/faq.png'

const MainMenu = ({ visible }) => {
  const isAuthenticated = localStorage.getItem('token')
  const navigate = useNavigate()
  // const login = () => navigate('/login')
  // const signUp = () => navigate('/sign-up')
  const [active, setActive] = useState('dashboard')
  const user = useSelector((state) => state.user.userDetails)

  const { pathname } = useLocation()

  useEffect(() => {
    switch (pathname) {
      case '/fantasy-league': {
        return setActive('home')
      }
      case '/professional-league': {
        return setActive('dashboard')
      }
      case '/player-roster': {
        return setActive('roster')
      }
      case '/team-line': {
        return setActive('line-up')
      }
      case '/team-trade': {
        return setActive('trade')
      }
      case '/player-auction': {
        return setActive('auctions')
      }
      case '/injured-reserve': {
        return setActive('injuries-reserve')
      }
      case '/league-rosters': {
        return setActive('league-rosters')
      }
      case '/free-agent': {
        return setActive('free-agents')
      }
      case '/league-standings': {
        return setActive('league-standings')
      }
      case '/player-standing': {
        return setActive('player-ranking')
      }
      case '/live-scoring': {
        return setActive('live-scoring')
      }
      case '/team-setting': {
        return setActive('team-setting')
      }
      case '/draft-picks': {
        return setActive('draft-picks')
      }
      case '/my-league': {
        return setActive('my-league')
      }
      case '/comissioner': {
        return setActive('comissioner')
      }
      default:
        setActive('')
    }
  }, [pathname])

  const navigatePath = (path) => {
    if (user?.team?.currentLeague?._id) {
      navigate(path)
    } else {
      notification.error({
        message: 'Please select any league from my leagues section first.',
        duration: 6,
      })
    }
  }

  return (
    <>
      <div className='sidebar_menu'>
        <div className='wrapper'>
          <div
            className={`sidebar_menu_item ${active === 'home' ? 'activeRoute' : ''}`}
            onClick={() => navigate('/fantasy-league')}
          >
            <HiOutlineHome />
            <p>HOME</p>
          </div>
          {isAuthenticated && (
            <>
              <div
                className={`sidebar_menu_item ${active === 'dashboard' ? 'activeRoute' : ''}`}
                onClick={() => navigatePath('/professional-league')}
              >
                <MdDashboard />
                <p>DASHBOARD</p>
              </div>
              <div
                className={`sidebar_menu_item ${active === 'roster' ? 'activeRoute' : ''}`}
                onClick={() => navigatePath('/player-roster')}
              >
                <PiUsersThreeLight />
                <p>roster</p>
              </div>
              <div
                className={`sidebar_menu_item ${active === 'line-up' ? 'activeRoute' : ''}`}
                onClick={() => navigatePath('/team-line')}
              >
                <FaRegChartBar />
                <p>LINE UP</p>
              </div>
              <div
                className={`sidebar_menu_item ${active === 'my-league' ? 'activeRoute' : ''}`}
                onClick={() => navigate('/my-league')}
              >
                <SiLeagueoflegends />
                <p>My Leagues</p>
              </div>
              <div
                className={`sidebar_menu_item ${active === 'trade' ? 'activeRoute' : ''}`}
                onClick={() => navigatePath('/team-trade')}
              >
                <GiTrade />
                <p>trade</p>
              </div>
              <div
                className={`sidebar_menu_item ${active === 'auctions' ? 'activeRoute' : ''}`}
                onClick={() => navigatePath('/player-auction')}
              >
                <RiAuctionLine />
                <p>auctions</p>
              </div>
              <div
                className={`sidebar_menu_item ${
                  active === 'injuries-reserve' ? 'activeRoute' : ''
                }`}
                onClick={() => navigatePath('/injured-reserve')}
              >
                <FaPlusCircle />
                <p>injuries reserve</p>
              </div>
              <div
                className={`sidebar_menu_item ${active === 'free-agents' ? 'activeRoute' : ''}`}
                onClick={() => navigatePath('/free-agent')}
              >
                <BsShop />
                <p>
                  free <br /> agents
                </p>
              </div>
              <div
                className={`sidebar_menu_item ${active === 'league-rosters' ? 'activeRoute' : ''}`}
                onClick={() => navigatePath('/league-rosters')}
              >
                <MdSportsHockey />
                <p>
                  league <br /> rosters
                </p>
              </div>
              <div
                className={`sidebar_menu_item ${
                  active === 'league-standings' ? 'activeRoute' : ''
                }`}
                onClick={() => navigatePath('/league-standings')}
              >
                <BsShop />
                <p>STANDINGS</p>
              </div>
              <div
                className={`sidebar_menu_item ${active === 'player-ranking' ? 'activeRoute' : ''}`}
                onClick={() => navigatePath('/player-standing')}
              >
                <GiStarMedal />
                <p>players ranking</p>
              </div>
              <div
                className={`sidebar_menu_item ${active === 'live-scoring' ? 'activeRoute' : ''}`}
                onClick={() => navigatePath('/live-scoring')}
              >
                <TbLivePhoto />
                <p>live scoring</p>
              </div>
              {(user?.team?.currentLeague?.createdBy === user?._id ||
                user?.team?.currentLeague?.coComissioner === user?._id) && (
                <div
                  className={`sidebar_menu_item ${active === 'comissioner' ? 'activeRoute' : ''}`}
                  onClick={() => navigate('/comissioner')}
                >
                  <img src={comissioner} width={'30px'} height={'30px'} />
                  <p style={{ fontSize: '8px' }}>Comissioner</p>
                </div>
              )}
              <div
                className={`sidebar_menu_item ${active === 'team-setting' ? 'activeRoute' : ''}`}
                onClick={() => navigatePath('/team-setting')}
              >
                <AiOutlineSetting />
                <p>team setting</p>
              </div>
            </>
          )}
          <div
            className={`sidebar_menu_item ${active === 'rules-book' ? 'activeRoute' : ''}`}
            onClick={() => {}}
          >
            <PiNotebookLight />
            <p>RULESBOOK</p>
          </div>
          <div
            className={`sidebar_menu_item ${active === 'draft-picks' ? 'activeRoute' : ''}`}
            onClick={() => navigate('/draft-picks')}
          >
            <RiDraftLine />
            <p>draft</p>
          </div>
          {/* <div
            className={`sidebar_menu_item ${active === 'faq' ? 'activeRoute' : ''}`}
            onClick={() => {}}
          >
            <FaQuestion />
            <p>faq</p>
          </div>
          <div
            className={`sidebar_menu_item ${active === 'token' ? 'activeRoute' : ''}`}
            onClick={() => window.open('https://sam-wallet-10b1f.web.app/')}
          >
            <GiCoins />
            <p>token</p>
          </div> */}
          <div
            className={`sidebar_menu_item ${active === 'job-search' ? 'activeRoute' : ''}`}
            onClick={() => {}}
          >
            <img src={Job} width={32} />
            <p>Job Search</p>
          </div>
          {/* <div
            className={`sidebar_menu_item ${active === 'Community' ? 'activeRoute' : ''}`}
            onClick={() => {}}
          >
            <img src={Community} width={32} />
            <p>Community</p>
          </div> */}
          {/* <div
            className={`sidebar_menu_item ${active === 'token' ? 'activeRoute' : ''}`}
            onClick={() => window.open('https://sam-wallet-10b1f.web.app/')}
          >
            <GiCoins />
            <p>sams token</p>
          </div> */}
          <div
            className={`sidebar_menu_item ${active === 'faq' ? 'activeRoute' : ''}`}
            onClick={() => {}}
          >
            <img src={FAQ} width={32} />
            {/* <FaQuestion /> */}
            <p>faq</p>
          </div>
          {/* <div
            className={`sidebar_menu_item ${active === 'support' ? 'activeRoute' : ''}`}
            onClick={() => window.open('https://discord.gg/pAb5B7Npmy')}
          >
            <img src={Support} width={32} />
            <p>Support</p>
          </div> */}
        </div>
      </div>

      {!isAuthenticated && (
        <div style={{ display: 'flex', flexDirection: 'row' }}>
          <LoginDropdown loginFromSideMenu drawerVisible={visible} />
          <Button className='login-btn signup-btn mobile' onClick={landingSignup}>
            Sign Up
          </Button>
        </div>
      )}
    </>
  )
}

export default MainMenu
